export const SET_USERCONTEXT = 'SET_USERCONTEXT'
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
